import { ref } from "vue";
import {store} from '@/helper/store'
const beautify = require('beautify');

let output = ref('')
let popUpOutput = ref('')

const generateHTML = () => {
    // Check if we have store data
    if (store.value && store.value.length > 0) {
        const tickerItems = store.value.map(item => `
            <article class="rlc-slide swiper-slide rlc-ticker-item">
                ${item.text}
                ${item.lineBreak ? '<br />' : ''}
                  <div style="display: inline-block;">
                ${item.cta.map(link => `
                  
                     ${link.checkedCTA && link.checkedCTA !== 'Pop Up Message' ? ' | ' : ''}
                        ${link.checkedCTA === 'Pop Up Message' ? `
                            <div class="promo-msg" style="cursor: pointer;">
                                ${link.checkedCTA ? ' | ' : ''}
                                <span class="rlc-link-underline">
                                    <u>${link.ctaText}</u>
                                </span>
                                <div class="promo-msg-content" style="display:none;">
                                    <div class="promo-wrap">${link.ctaValue}</div>
                                </div>
                            </div>
                        ` : ''}
                        ${link.checkedCTA === 'Link' ? `<a href="${link.ctaValue}"><u>${link.ctaText}</u></a>` : ''}
                        ${link.checkedCTA === 'PDF' ? `<u><a target="_blank" href="../../../Library-Sites-RalphLauren_EU_Library/default/content/pdf/${link.ctaValue}?$staticlink$">${link.ctaText}</a></u>` : ''}
                `).join('')}
                    </div>
            </article>
        `).join('');

        const content = `
        <link href="../../../Library-Sites-RalphLauren_EU_Library/default/_common/css/rlc-ticker.1.1.min.css?$staticlink$"
        rel="stylesheet" type="text/css" />

        <div id="rlc-ticker-wrapper">
            <section class="rlc-ticker swiper-container">
                <div class="swiper-wrapper">
                    ${tickerItems}
                </div>
            </section>
        </div>

        <style>
            .rlc-ticker-item,
            .rlc-ticker-item a {
                font-size: 0.75rem !important;
            }

            #rlc-ticker-wrapper .rlc-slide {
                padding: 0.25em 1em !important;
            }

            body .promo-dialog.ui-dialog .ui-dialog-content.dialog-content {
                height: auto !important;
                max-height: unset !important;
            }

            .header-promotion .rlc-all-hidden {
                display: none !important;
            }

        </style>

        <div class="rlc-all-hidden"
            data-customjs="../../../Library-Sites-RalphLauren_EU_Library/default/_common/js/rlc-ticker.1.1.7.min.js?$staticlink$"
            id="rlc-tickerjs">
        </div>`
        output.value = beautify(content, {format: 'html'})
    } else {
        // If no store data, try to get from SFCC_content
        let html = document.querySelector('#SFCC_content')?.innerHTML;
        if (html) {
            html = html.replaceAll('<!--v-if-->', '')
            html = html.replaceAll('<!---->', '')
            const content = `
            <link href="../../../Library-Sites-RalphLauren_EU_Library/default/_common/css/rlc-ticker.1.1.min.css?$staticlink$"
            rel="stylesheet" type="text/css" />

            <div id="rlc-ticker-wrapper">
                <section class="rlc-ticker swiper-container">
                    <div class="swiper-wrapper">
                        ${html}
                    </div>
                </section>
            </div>

            <style>
                .rlc-ticker-item,
                .rlc-ticker-item a {
                    font-size: 0.75rem !important;
                }

                #rlc-ticker-wrapper .rlc-slide {
                    padding: 0.25em 1em !important;
                }

                body .promo-dialog.ui-dialog .ui-dialog-content.dialog-content {
                    height: auto !important;
                    max-height: unset !important;
                }

                .header-promotion .rlc-all-hidden {
                    display: none !important;
                }
            </style>

            <div class="rlc-all-hidden"
                data-customjs="../../../Library-Sites-RalphLauren_EU_Library/default/_common/js/rlc-ticker.1.1.7.min.js?$staticlink$"
                id="rlc-tickerjs">
            </div>`
            output.value = beautify(content, {format: 'html'})
        }
    }
}

const saveHTML = () => {
    const local = window.location.pathname
    const jsonFile = JSON.stringify({data: store.value})
    switch (local) {
    case '/': localStorage.setItem('savedAUHTML', jsonFile); break;
    case '/KR': localStorage.setItem('savedKRHTML', jsonFile); break;
    case '/TW': localStorage.setItem('savedTWHTML', jsonFile); break;
    case '/MY': localStorage.setItem('savedMYHTML', jsonFile); break;
    case '/SG': localStorage.setItem('savedSGHTML', jsonFile); break;
    case '/JP': localStorage.setItem('savedJPHTML', jsonFile); break;
    }
}

const clearCache = () => {
  const local = window.location.pathname
  switch (local) {
    case '/':   localStorage.removeItem('savedAUHTML'); break;
    case '/KR': localStorage.removeItem('savedKRHTML'); break;
    case '/TW': localStorage.removeItem('savedTWHTML'); break;
    case '/MY': localStorage.removeItem('savedMYHTML'); break;
    case '/SG': localStorage.removeItem('savedSGHTML'); break;
    case '/JP': localStorage.removeItem('savedJPHTML'); break;
    }
    location.reload();
}

const generatePopUpHTML = () => {
  let html = document.querySelector('#popUp_content').innerHTML;
  html = html.replaceAll('<!--v-if-->', '')
  popUpOutput.value = beautify(html, {format: 'html'})
}


export {generateHTML, saveHTML, clearCache, output, popUpOutput, generatePopUpHTML}